import { GET_BASE_URL } from "../constants/apiEndpoints";
import { readLoungeAuthorizedData } from "../utils/loungeAuthRefresh";

export const getAllMyCollectionApi = async () => {
  return readLoungeAuthorizedData(
    GET_BASE_URL + `/api/v1/getMyCollection`,
    "getMyCollection"
  );
};
